import $ from 'jquery';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import i18n from '../../config/i18n';

class Pagination extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePageNumber: 1,
    };

    this.handleClickPage = this.handleClickPage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isFirstPage) {
      this.setState({
        activePageNumber: 1,
      });
    }
  }

  handleClickPage(e) {
    const targetPageNumber = parseInt($(e.target).attr('data-page'), 10);
    if (e.target.tagName === 'A' && this.state.activePageNumber !== targetPageNumber) {
      this.setState({ activePageNumber: targetPageNumber });
      this.props.onClickPage.call(this, targetPageNumber - 1);
    }
  }

  render() {
    if (this.props.isLoading || this.props.pageInfo === {}) {
      return (
        <div />
      );
    }

    const pageInfo = this.props.pageInfo;
    if (pageInfo.totalPages === 1) {
      return (
        <div />
      );
    }

    const totalPageCount = pageInfo ? pageInfo.totalPages : 0;
    let i;
    let listItems = [];
    const activePageNumber = this.state.activePageNumber;
    if (totalPageCount === 0) {
      return (
        <div className="text-right">
          <ul className="pagination">
            {i18n.t('noItemAvailable')}
          </ul>
        </div>
      );
    }

    if (totalPageCount < 7) {
      for (i = 1; i <= totalPageCount; i += 1) {
        listItems.push((
          <li className={classNames({ active: activePageNumber === i })} key={i}>
            <a data-page={i}>{i}</a>
          </li>
        ));
      }
    } else if (activePageNumber < 4) {
      for (i = 1; i < 5; i += 1) {
        listItems.push((
          <li className={classNames({ active: activePageNumber === i })} key={i}>
            <a data-page={i}>{i}</a>
          </li>
        ));
      }
      listItems.push((
        <li key="separator-1"><span className="pagination-separator" >...</span></li>
      ));
      listItems.push((
        <li key={totalPageCount + 1}>
          <a data-page={totalPageCount}>{totalPageCount}</a>
        </li>
      ));
    } else if (activePageNumber > 3 && activePageNumber <= totalPageCount - 3) {
      listItems = [
        (
          <li key={1}>
            <a data-page={1}>{1}</a>
          </li>
        ),
        (
          <li key="separator-1"><span className="pagination-separator" >...</span></li>
        ),
        (
          <li key={activePageNumber - 1}>
            <a data-page={activePageNumber - 1}>{activePageNumber - 1}</a>
          </li>
        ),
        (
          <li className="active" key={activePageNumber}>
            <a data-page={activePageNumber}>{activePageNumber}</a>
          </li>
        ),
        (
          <li key={activePageNumber + 1}>
            <a data-page={activePageNumber + 1}>{activePageNumber + 1}</a>
          </li>
        ),
        (
          <li key="separator-2"><span className="pagination-separator" >...</span></li>
        ),
        (
          <li key={totalPageCount}>
            <a data-page={totalPageCount}>{totalPageCount}</a>
          </li>
        ),

      ];
    } else {
      // at the end of the list
      listItems.push((
        <li key={1}>
          <a data-page={1}>{1}</a>
        </li>
      ));
      listItems.push((
        <li key="separator-1"><span className="pagination-separator" >...</span></li>
      ));
      for (i = totalPageCount - 3; i <= totalPageCount; i += 1) {
        listItems.push((
          <li className={classNames({ active: activePageNumber === i })} key={i}>
            <a data-page={i}>{i}</a>
          </li>
        ));
      }
    }
    return (
      <div className="text-right">
        <ul className="pagination" role="button" onClick={this.handleClickPage}>
          {listItems}
        </ul>
      </div>
    );
  }
}

Pagination.propTypes = {
  onClickPage: PropTypes.func,
  isLoading: PropTypes.bool,
  pageInfo: PropTypes.object,
  isFirstPage: PropTypes.bool,
};

Pagination.defaultProps = {
  onClickPage: () => {},
  isLoading: false,
  pageInfo: {},
  isFirstPage: true,
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/shared/Pagination.js